import { render, staticRenderFns } from "./DexPointModal.vue?vue&type=template&id=3dab372c&scoped=true"
import script from "./DexPointModal.vue?vue&type=script&lang=ts"
export * from "./DexPointModal.vue?vue&type=script&lang=ts"
import style0 from "./DexPointModal.vue?vue&type=style&index=0&id=3dab372c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab372c",
  null
  
)

export default component.exports